import { render, staticRenderFns } from "./SymbolO.vue?vue&type=template&id=0b2a72e7&scoped=true&"
import script from "./SymbolO.vue?vue&type=script&lang=js&"
export * from "./SymbolO.vue?vue&type=script&lang=js&"
import style0 from "./SymbolO.vue?vue&type=style&index=0&id=0b2a72e7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2a72e7",
  null
  
)

export default component.exports